import React, { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import SignInPage from './pages/SignInPage';
import HomePage from './pages/HomePage';
import CheckoutPage from './pages/CheckoutPage';
import ThankYouPage from './pages/ThankYouPage';

function AppContent() {
  const { user, loading, signOut } = useAuth();
  const [currentPage, setCurrentPage] = useState('home');

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <SignInPage />;
  }

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return (
          <HomePage 
            onNavigateToCheckout={() => setCurrentPage('checkout')}
            onSignOut={signOut}
          />
        );
      case 'checkout':
        return (
          <CheckoutPage
            onNavigateBack={() => setCurrentPage('home')}
            onComplete={() => setCurrentPage('thankyou')}
          />
        );
      case 'thankyou':
        return <ThankYouPage onNavigateBack={() => setCurrentPage('home')} />;
      default:
        return (
          <HomePage 
            onNavigateToCheckout={() => setCurrentPage('checkout')}
            onSignOut={signOut}
          />
        );
    }
  };

  return (
    <CartProvider>
      <div className="App">
        {renderPage()}
      </div>
    </CartProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
